import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import clientConfig from "/src/config/client.js";
import "aos/dist/aos.css";
import VueGtag from "vue-gtag";
import VueScrollTo from "vue-scrollto";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "mdb-vue-ui-kit/css/mdb.min.css";

const app = createApp(App);

app
  .use(store)
  .use(router)
  .use(VueGtag, {
    appName: "Monument",
    pageTrackerScreenviewEnabled: true,
    config: {
      id: "G-TNDDZQ4FYY",
      cookie_flags: "SameSite=None;Secure",
      params: {
        send_page_view: false,
        debug_mode: false,
      },
    },
  })
  .use(VueScrollTo)
  .mount("#app");

// Update the page title to the client's name
document.title = clientConfig.content.general.clientName;
